import { useActivityStore } from '@/store/activity';
import { useActivityQueueStore } from '@/store/activity-queue';
import { useActivitySessionStore } from '@/store/activity-session';

import { resetPaywallOfferResolvedOrders } from './scenes/paywall';
import { resetWidgetShowTracked } from './widget-show-track-cache';

/**
 * 登录态切换成功后清空上一身份的活动状态。
 * 当前页面场景由 ActivityQueue 保留；此处不重新触发冷启活动请求。
 */
export function clearActivityStateAfterAuthChange(): void {
    // 先移除 current / waiting，避免清 ActivityStore 时队列短暂引用已失效活动。
    useActivityQueueStore.getState().clearForAuthChange();
    useActivitySessionStore.getState().reset();
    useActivityStore.getState().reset();
    resetWidgetShowTracked();
    resetPaywallOfferResolvedOrders();
}
